class TimePicker extends HTMLElement {
    constructor() {
        super();
    }

    public get getHourElement(): HTMLInputElement {
        return this.querySelector("[data-type='hour']");
    }

    public get getMinuteElement(): HTMLInputElement {
        return this.querySelector("[data-type='minute']");
    }

    /**
     * Gets the time input used to combine hour and minute
     */
    public get getTimeElement(): HTMLInputElement {
        return this.querySelector(`#${this.dataset.dateInput}`);
    }

    connectedCallback() {
        if (!this.getHourElement || !this.getMinuteElement || !this.getTimeElement)
        {
            console.error("Missing hour, minute or time element");
            return;
        }

        const initialTime = this.getTimeElement.value;

        if (initialTime) {
            const time = initialTime.split(':');
            this.getHourElement.value = time[0];
            this.getMinuteElement.value = time[1];
        }

        this.getHourElement.max = '23';
        this.getHourElement.min = '00';

        this.getMinuteElement.max = '59';
        this.getMinuteElement.min = '00';

        this.getMinuteElement.addEventListener('change', this.onChange.bind(this));
        this.getMinuteElement.addEventListener('input', this.onInput.bind(this));

        this.getHourElement.addEventListener('change', this.onChange.bind(this));
        this.getHourElement.addEventListener('input', this.onInput.bind(this));
    }

    disconnectedCallback() {
        this.getMinuteElement.removeEventListener('change', this.onChange);
        this.getMinuteElement.removeEventListener('input', this.onInput);

        this.getHourElement.removeEventListener('change', this.onChange);
        this.getHourElement.removeEventListener('input', this.onInput);
    }

    private onChange(ev: InputEvent) {
        const target = <HTMLInputElement>ev.target;
        if (parseInt(target.value) > parseInt(target.max)) {
            target.value = target.max;
        }

        if (parseInt(target.value) < parseInt(target.min)) {
            target.value = target.min
        }

        if (target.value.length == 1) {
            const value = target.value.padStart(2, '0');
            target.value = value;
        }

        this.getTimeElement.value = `${this.getHourElement.value}:${this.getMinuteElement.value}`;
    }

    private onInput(ev: InputEvent) {
        const target = <HTMLInputElement>ev.target;
        // Change focus to minute input when hour is filled
        if (target.dataset.type == 'hour' &&
            target.value.length == 2 &&
            // Dont change focus if user is deleting characters
            ev.data != null) {
            this.getMinuteElement.focus();
        }
    }
}

customElements.define("time-picker", TimePicker);